import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

const Androidbuss = () => {
  return (
    <div className="androidbuss tekrevol_dark_bg p-100">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <h2><span>Tekrevol’s</span> Streaming App Development</h2>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                       <p>We understand the needs of the modern consumer and can build a perfect streaming app complete with all the important features to make the app a sure shot hit with the audiences.</p>
                       <p>Here are some top features that we can incorporate for you in your music or video streaming app:</p>
                    </Col>
                </Row>
                <Row className="h-100 buss-padd">
                <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                    <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Play on Demand</h6>
                            <p>Users can play any content or media file whenever they want.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Direct Customer Engagement</h6>
                            <p>Apps provide a direct and interactive channel to connect with customers, encouraging stronger relationships.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Profile</h6>
                            <p>Users can create their personalized profiles that will allow them to save their viewing history, present them with recommended video or music options and much more.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Recommendation Algorithm</h6>
                            <p>Users will get video or music recommendations based on their viewing histories in order to give them a more personalized viewer experience.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Simultaneous Log-ins</h6>
                            <p>The app will be able to handle any number of simultaneous logins as per requirements.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Rate</h6>
                            <p>Users will be able to rate the video or media files as they deem right.</p>
                        </div>
                    </div>
                </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Androidbuss